export enum CampaignContractType {
    STANDARD_CAMPAIGN = 'standard_campaign',
    LONG_TERM_CAMPAIGN = 'long_term',
    PARTNER_CAMPAIGN = 'agency_partner_campaign',
    CHILD_CAMPAIGN = 'child_campaign',
}
